export default __webpack_public_path__ + "static/media/awo_hero.6f7ef725.jpg";